/**
 * @packageDocumentation
 * Constructs and animates the parallax background layers, including clouds and lighting effects that sit behind the card stage.
 */
import * as PIXI from "pixi.js";  
import { Spine } from "@esotericsoftware/spine-pixi-v8"; 
import { Assets } from 'pixi.js';
import { StartAppResize } from "../resizer"; 
import { gsap } from "gsap/gsap-core";

/**
 * Class that handles background animations including clouds and spine animations
 * @class backgroundAnimations
 */
export class backgroundAnimations{
    /** 
     * PIXI Application instance for background rendering
     * @private
     * @type {PIXI.Application} 
     */
    private app_bg!:PIXI.Application;
    bgSprite!:PIXI.Sprite;
    /** 
     * Array to store cloud sprite references
     * @private
     * @type {PIXI.Sprite[]}
     */
    private cloudsArr!:PIXI.Sprite[];

    /**
     * Creates a background animations instance
     * @constructor
     * @param {number} app_width - Width of the application viewport
     * @param {number} app_height - Height of the application viewport
     * @param {number} resize_to_device - Resize factor for device scaling
     */
    constructor(private app_width:number,private app_height:number,private resize_to_device:number){
        (async()=>{
            this.app_bg = new PIXI.Application();
            await this.app_bg.init({ width: app_width, height: app_height, backgroundAlpha : 0,resolution:2 });
            document.body.appendChild(this.app_bg.canvas);
            StartAppResize({ 
              app:this.app_bg,
              app_width:this.app_width,
              app_height:this.app_height,
              resize_to_device:this.resize_to_device,
              transformOrigin_Y:50,
              translate_Y:50,
              app_top:50,
              app_name:"app_bg",
              // LSresizer:
            }) 
        })()
    }

    /**
     * Creates and adds wide background sprite to stage
     * @public
     * @returns {void}
     */
    public formWideBg(){
        const bgSprite = new PIXI.Sprite(Assets.get("bg_game_wide"))
        bgSprite.width = this.app_bg.screen.width;
        bgSprite.height = this.app_bg.screen.height;
        bgSprite.anchor.set(0);
        this.bgSprite = bgSprite;
        this.app_bg.stage.addChild(bgSprite); 
      }
    public formWideBg_1(){
        const bgSprite = new PIXI.Sprite(Assets.get("bg_game_wide_top"))
        bgSprite.width = this.app_bg.screen.width;
        bgSprite.height = this.app_bg.screen.height;
        bgSprite.anchor.set(0);
        this.app_bg.stage.addChild(bgSprite); 
    }
    /**
     * Creates and adds spine animation to background
     * @public
     * @returns {void}
     */
    public formBgAnimations(){
    
      }

    /**
     * Creates and positions cloud sprites in the background
     * @public
     * @returns {void}
     */
    public formCloudAnimations(){
         this.cloudsArr = [];
        //  const airPlane = new PIXI.Sprite(Assets.get(`air_plane`))
        //  airPlane.anchor.set(0.5);
        //  airPlane.scale.set(0.09)
        //  this.app_bg.stage.addChild(airPlane);
        //  airPlane.x = airPlane.width/2+(200*3); 
        //  this.cloudsArr.push(airPlane);
        //  airPlane.y = 100-(25-(Math.random()*50));

        for(let i=1;i<4;i++){
            const Cloud = new PIXI.Sprite(Assets.get(`cloud_${i}`))
            Cloud.anchor.set(0.5);
            this.app_bg.stage.addChild(Cloud);
            Cloud.x = 570*i; 
            if(i>0){ 
                Cloud.y = 100-(25-(Math.random()*50));
            }
            if(i>5){
                Cloud.y = 170+(25-(Math.random()*50));
            }
            
            if(i>10){
                Cloud.y = 200-(25-(Math.random()*50));
            }
      
            this.cloudsArr.push(Cloud)
        } 
    }

    /**
     * Initiates movement animation for all cloud sprites
     * @public
     * @returns {void}
     */
    public move_all_clouds(){
        this.cloudsArr.forEach(element => {
            this.move_a_cloud(element)
        }); 
    }

    /**
     * Animates a single cloud sprite with continuous movement
     * @private
     * @param {PIXI.Sprite} cloud - The cloud sprite to animate
     * @returns {void}
     */
    move_a_cloud(cloud:PIXI.Sprite){
        let distance = cloud.x;  
        gsap.to(cloud,{duration:distance/(Math.random()*6+3),x:-cloud.width,onComplete:()=>{
            cloud.x = this.app_bg.stage.width+cloud.width
            this.move_a_cloud(cloud)
        }})
    }
} 
 
